import { render, staticRenderFns } from "./zjcenter.vue?vue&type=template&id=f2742eaa&scoped=true&"
import script from "./zjcenter.vue?vue&type=script&lang=js&"
export * from "./zjcenter.vue?vue&type=script&lang=js&"
import style0 from "./zjcenter.vue?vue&type=style&index=0&id=f2742eaa&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2742eaa",
  null
  
)

export default component.exports